import { render, staticRenderFns } from "./Retencioncomponent_listadodocumentos.vue?vue&type=template&id=56cf84e3"
import script from "./Retencioncomponent_listadodocumentos.vue?vue&type=script&lang=js"
export * from "./Retencioncomponent_listadodocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports